<template>
  <SalesSkeleton v-if="loading" />
  <div v-else class="salesGraph">
    <div class="salesGraph__selection-wrapper">
      <div class="salesGraph__selection-wrapper-left">
        <SelectBox
          class="selectBox"
          v-model="selectedDate"
          :options="selectBoxOptionsArr"
          label="label"
          placeholder="Zaman"
        />
        <DatePickerV2
          class="datePicker"
          title="Tarih Aralığı Seç"
          @selectedValue="setSelectedCustomDate"
          range
          :disable="datePickerIsDisabled"
          :max-date="new Date().getTime()"
        />
      </div>
      <div class="salesGraph__selection-wrapper-right">
        <span class="text">Sipariş Adedi : </span>
        <span class="text-bold">{{ chartData?.totalOrderCount }}</span>
      </div>
    </div>
    <div class="salesGraph__chart-wrapper">
      <Loading
        :className="'salesGraph__chart-wrapper loading'"
        v-if="loading"
      />
      <chart v-else :chartData="chartData?.orderCountByDateModelList"></chart>
    </div>
  </div>
</template>

<script>
import { Loading, SelectBox, DatePickerV2 } from '@n11/so-ui-components';
import { daysToDisplayed } from '@/utils/daysToDisplayed';
import SalesSkeleton from '@/components/SalesGraph/SalesSkeleton';
import chart from './chart';

export default {
  components: {
    chart,
    DatePickerV2,
    Loading,
    SelectBox,
    SalesSkeleton,
  },
  props: {
    chartData: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
    },
  },
  methods: {
    setSelectedCustomDate(val) {
      const [startDate, endDate] = val;
      if (this.selectedDate.id === -1) {
        this.selectedDate.startDate = startDate;
        this.selectedDate.endDate = endDate;
        this.selectedDay(this.selectedDate);
      }
    },
    selectedDay(e) {
      this.$emit('requestNewDays', e);
    },
  },
  watch: {
    selectedDate(val) {
      if (val.id !== -1) {
        this.datePickerIsDisabled = true;
        this.selectedDay(val);
      } else {
        this.datePickerIsDisabled = false;
      }
    },
  },
  computed: {
    selectBoxOptionsArr() {
      const newArr = [];
      Object.keys(daysToDisplayed).forEach((item) => {
        newArr.push(daysToDisplayed[item]);
      });
      return newArr;
    },
  },
  mounted() {
    this.selectedDay(this.selectedDate);
  },
  data() {
    return {
      daysToDisplayed,
      selectedDate: daysToDisplayed.lastWeek,
      datePickerIsDisabled: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.salesGraph {
  display: flex;
  flex-direction: column;
  padding-top: 18px;
  &__selection-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 578px) {
      justify-content: center;
      flex-wrap: wrap;
    }
    &-left {
      display: flex;
      flex-direction: row;
      @media screen and (max-width: 578px) {
        flex-wrap: wrap;
      }
      .selectBox {
        width: 190px;
        margin-right: 16px;
        @media screen and (max-width: 578px) {
          width: 100%;
          margin-right: 0;
          margin-bottom: 10px;
        }
      }
      .datePicker {
        width: 220px;
        @media screen and (max-width: 578px) {
          width: 100%;
          margin-bottom: 10px;
        }
      }
    }
    &-right {
      display: flex;
      flex-direction: row;
      align-items: center;
      @media screen and (max-width: 578px) {
        width: 100%;
        flex-wrap: wrap;
        margin-bottom: 10px;
        justify-content: flex-end;
      }
      .text {
        font-size: 13px;
        line-height: 1.85;
        font-weight: normal;
        text-align: left;
        color: #1f1f1f;
        &-bold {
          font-weight: bold;
          text-align: right;
          margin-left: 5px;
        }
      }
      .tooltip {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid black;
        width: 20px;
        height: 20px;
        margin-left: 8px;
      }
    }
  }
  &__chart-wrapper {
    width: 100%;
    height: 284px;
    &.loading {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.datepicker {
  &__input {
    border-radius: 6px;
    border: solid 1px #c7c7c7;
    padding: 12px 12px 12px 16px;
    font-size: 14px;
    color: #1f1f1f;
    margin-right: 10px;
  }
}
</style>
